import type { FC, MouseEvent, MouseEventHandler, ReactNode } from 'react'
import { useRecipient, useRecipientOpsDispatch } from '../../recipient/RecipientProvider'
import { useRouter } from 'next/router'
import CartButton from './CartButton'

const ProceedButton: FC<{
  href?: string
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined
  children?: ReactNode
}> = ({ children, ...buttonProps }) => {
  return (
    <CartButton
      {...buttonProps}
      className="min-w-full sm:min-w-0 h-full"
      data-cy="shop-add-to-cart-confirmation-checkout"
      icon="arrow"
    >
      {children}
    </CartButton>
  )
}

const SelectRecipientBeforeCheckout: FC = () => {
  const dispatch = useRecipientOpsDispatch()
  const router = useRouter()

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    // A special case where we want to keep track whether the user
    // is already checking out, so we can adjust the /recipient page
    // and don't interrupt the checkout flow when i.e. decides to login
    // in between and return back to the page
    // mainly for newcomers
    dispatch({ type: 'toggle-checkout-in-progress', initiatedCheckout: true })
    router.push('/recipient')
  }

  return <ProceedButton onClick={(e) => handleClick(e)}>Proceed to Checkout</ProceedButton>
}

const ProceedToCheckout: FC = () => {
  const { currentRecipient } = useRecipient()

  return (
    <div className="flex flex-col space-y-2 h-full">
      {!currentRecipient ? (
        <SelectRecipientBeforeCheckout />
      ) : (
        <ProceedButton href="/checkout">Proceed to Checkout</ProceedButton>
      )}
    </div>
  )
}

export default ProceedToCheckout
